export default {
  labels: {
    pickup_time: 'Abholzeit',
    delivery_time: 'Lieferzeit',
    today: 'Heute',
  },
};
